function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fff"
}, React.createElement("path", {
  d: "M17.395 19.06L8.91 10.575l-1.414 1.414 8.485 8.485z"
}), React.createElement("path", {
  d: "M15.985 3.5L7.5 11.985 8.914 13.4 17.4 4.914z"
}));

var SvgCaratLeft = function SvgCaratLeft(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24
  }, props), _ref);
};

export default SvgCaratLeft;